import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/user/type/tenant.user.type.mutation.gql"
import type {
  TenantUserTypeMutation,
  TenantUserTypeMutationVariables,
} from "@/v2-backoffice-client/tenant/user/type/__types__/tenant.user.type.mutation"

type Options = MutationHookOptions<
  TenantUserTypeMutation,
  TenantUserTypeMutationVariables
>

export function useTenantUserTypeMutation(options?: Options) {
  return useMutation<TenantUserTypeMutation, TenantUserTypeMutationVariables>(
    mutation,
    options,
  )
}
